import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { IconButton, ListItemButton, Menu } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import {
  Button,
  Box,
  Divider,
} from '@mui/material';
import StoreContext from '../context/StoreContext';
import UserContext from '../context/UserContext';
import { useHistory } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FeatureFlagBadge from './FeatureFlagBadge';
import CloseIcon from '@mui/icons-material/Close';
import { signInWithRedirect } from 'aws-amplify/auth';
import LyftIcon from '../utils/LyftIcon';

const NavDrawer = () => {
  const {
    storeId,
    nextAppt,
    courtesyLyft,
    smartPromiseTime,
    vehicleReadySms,
    promisedTimeSms,
    globalBeback,
    promiseTimeAppointments
  } = useContext(StoreContext);

  const { isFeaturesAdmin, isAdmin } = useContext(UserContext);

  const [openMenu, setOpenMenu] = useState(false);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setAnchorEl(open ? event.currentTarget : null);
    setOpenMenu(open);
  };

  const goToSettings = () => {
    history.push('/settings');
  };

  const goToLyftSettings = () => {
    history.push('/lyft-settings');
  };

  const goToLogout = () => {
    history.push('/logout');
  }

  const sideList = () => (
    <Box
      className='side-list nav-list'
      role='presentation'
    >
      <IconButton
        aria-label="close modal"
        onClick={toggleDrawer(false)}
        sx={{ alignSelf: "flex-end", marginRight: ".25em", padding: '.2em' }}
      >
        <CloseIcon style={{ padding: 0 }} />
      </IconButton>


      <List sx={{paddingTop: 0}}>
        <Link to='/logout' className='nav-menu-link'>
          <ListItemButton key={0} sx={{ paddingX: 0, paddingTop: 0 }}>
            <ListItem sx={{paddingTop: 0}}>
              <ListItemIcon>
                <AddCircleOutlineIcon />
              </ListItemIcon>
              <ListItemText primary='Log Out' />
            </ListItem>
          </ListItemButton>
        </Link>

        <Divider variant='middle' />
        {isAdmin && isFeaturesAdmin && (
          <>
            <ListItemButton
              key={1}
              onClick={(e) => {
                goToSettings();
              }}
              sx={{ paddingX: 0 }}
            >
              <ListItem>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primary='Settings' />
                
                <ListItemIcon sx={{justifyContent: 'end'}}>
                  <ArrowForwardIosIcon fontSize="small" />
                </ListItemIcon>
              </ListItem>
            </ListItemButton>
            <Divider variant='middle' />
          </>
        )}
        {isAdmin && isFeaturesAdmin && (
          <>
            <ListItemButton
              key={1}
              onClick={(e) => {
                goToLyftSettings();
              }}
              sx={{ paddingX: 0 }}
            >
              <ListItem>
                <ListItemIcon>
                  <LyftIcon width={24} height={24} />
                </ListItemIcon>
                <ListItemText primary='Lyft settings' />
                
                <ListItemIcon sx={{justifyContent: 'end'}}>
                  <ArrowForwardIosIcon fontSize="small" />
                </ListItemIcon>
              </ListItem>
            </ListItemButton>
            <Divider variant='middle' />
          </>
        )}
        { isAdmin &&
          localStorage.getItem("isInStore") ? 
          <ListItemButton
            key={2}
            onClick={async (e) => {
              await localStorage.clear();
              signInWithRedirect({ provider: { custom: 'Okta'}});
            }}
            sx={{ paddingX: 0 }}
          >
            <ListItem>
              <ListItemIcon>
                <SyncLockIcon />
              </ListItemIcon>
              <ListItemText primary='Change to okta' />
            </ListItem>
          </ListItemButton>
          : isAdmin && 
          <ListItemButton
            key={2}
            onClick={(e) => {
              goToLogout();
            }}
            sx={{ paddingX: 0 }}
          >
            <ListItem>
              <ListItemIcon>
                <SyncLockIcon />
              </ListItemIcon>
              <ListItemText primary='Change to in store' />
            </ListItem>
          </ListItemButton>
        }  
        {
          parseInt(storeId) !== 1 && isAdmin && (
            <>
              <Divider variant='middle' />
              <ListItem className='feature-flag-container'>
                <p className='feature-flag-title'>
                  Integrations: Store {storeId}
                </p>

                <FeatureFlagBadge
                  title='Next Appointment'
                  activeSetting={nextAppt}
                />

                <FeatureFlagBadge
                  title='Suggested Promise Time'
                  activeSetting={smartPromiseTime}
                />

                <FeatureFlagBadge
                  title='Courtesy Rides'
                  activeSetting={courtesyLyft}
                />
              </ListItem>

              <Divider variant='middle' />

              <ListItem className='feature-flag-container'>
                <p className='feature-flag-title'>
                  SMS Automations: Store {storeId}
                </p>

                <FeatureFlagBadge
                  title='Vehicle Ready - WO Completed'
                  activeSetting={vehicleReadySms}
                />
                <FeatureFlagBadge
                  title='Global Beback SMS'
                  activeSetting={globalBeback}
                />
                <FeatureFlagBadge
                  title='Promise Time'
                  activeSetting={promisedTimeSms}
                />
                <FeatureFlagBadge
                  title='Promise Time - Appointments'
                  activeSetting={promiseTimeAppointments}
                />
              </ListItem>
            </>
          )
        }
      </List>

      
    </Box>
  );

  return (
    <div>
      <Button
        sx={{ paddingTop: '10px', paddingBottom: '10px' }}
        onClick={toggleDrawer(true)}
      >
        {' '}
        <MenuRoundedIcon style={{ color: '#000' }} fontSize='large' />
      </Button>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        open={openMenu}
        onClick={toggleDrawer(false)}
        style={{ zIndex: 10 }}
        slotProps={{paper: {sx: {boxShadow: '0px 5px 5px rgba(0, 0, 0, .2)'}}}}
      >
        {sideList()}
      </Menu>
    </div>
  );
};

export default NavDrawer;
